// chatCompactUi.js — apply Code chat compact mode locally (no agent/tools required).

export const CHAT_DENSITY_KEY = 'apolo:chatDensity';
export const CHAT_DENSITY_EVENT = 'apolo:chatDensityChanged';

export function isCompactChatRequest(text) {
  const s = String(text || '').toLowerCase();
  return /compact|compactar|densidade|mais texto|chat.*tela|apareça mais texto|shad-pro|liquid-glass/.test(s);
}

/** UI-only request: compact the chat viewport, not refactor repo files. */
export function isUiOnlyCompactRequest(text) {
  return isCompactChatRequest(text) && !/write_file|refator|implementar no código|commit|pr\b/.test(String(text || '').toLowerCase());
}

export function applyCompactChatUi() {
  try {
    localStorage.setItem(CHAT_DENSITY_KEY, 'compact');
    localStorage.setItem('apolo:chatToolCardsCollapsed', 'true');
  } catch {
    /* private mode */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHAT_DENSITY_EVENT, { detail: 'compact' }));
  }
}

export function compactChatAckMessage() {
  return [
    '✅ Chat em modo **compacto** (aplicado na hora — sem agente).',
    'Mais texto visível: gaps menores, tool cards colapsados, timestamps escondidos.',
    'Toggle: botão Rows2/Rows3 na toolbar do chat.',
  ].join('\n');
}
